import Skeleton from '@/common/view/Skeleton';
import Text from '@/common/view/Text';
import { useCustomerDetailPageContext } from '../datacontroller/CustomerDetailPageContext';

interface InfoRowProps {
  label: string;
  value?: string | number;
}

export const CustomerInfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  const { isCustomerDetailLoading } = useCustomerDetailPageContext();

  return (
    <div className="flex justify-between items-center gap-4">
      <Text typo="body4" color="gray50" className="w-32 flex-shrink-0">
        {label}
      </Text>
      {isCustomerDetailLoading ? (
        <Skeleton width={120} height={20} />
      ) : (
        <Text typo="body4" color="grayBlack">
          {value ?? '-'}
        </Text>
      )}
    </div>
  );
};
